export const filterConst = {
  FILTERDEFAULT: 0,
  FILTERDATE: 1,
  FILTERMODEL: 2,
  FILTERDOCKEY: 3,
  FILTERNUMBER: 4,
  FILTERCUSTOMERNAME: 5,
  FILTERCUSTOMERDENTIFICATION: 6,
  FILTERSTATUS: 7
}



// WEBPACK FOOTER //
// ./src/public/api/filterConst.js